var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-default-cell",style:(_vm.cssValues)},[_vm._v(" "+_vm._s(_vm.item[_vm.category.field])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }